import { Button } from "@/components/ui/button";
import { Share2 } from "lucide-react";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";

interface Props {
  spotId: string;
  spotAddress?: string;
  size?: "sm" | "default" | "icon";
  variant?: "ghost" | "outline" | "default";
}

export default function ShareSpotButton({ spotId, spotAddress, size = "icon", variant = "ghost" }: Props) {
  const { toast } = useToast();

  const onShare = async (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    const { data: { user } } = await supabase.auth.getUser();
    let ref = "";
    if (user) {
      const { data } = await supabase.from("referral_codes").select("code").eq("user_id", user.id).maybeSingle();
      if (data?.code) ref = `?ref=${data.code}`;
    }
    const url = `${window.location.origin}/search?spot=${spotId}${ref}`;
    const text = `Check out this parking spot${spotAddress ? ` at ${spotAddress}` : ""} on Bayzo`;

    if (navigator.share) {
      try { await navigator.share({ title: "Bayzo parking", text, url }); return; } catch {}
    }
    await navigator.clipboard.writeText(url);
    toast({ title: "Link copied", description: "Share it with anyone." });
  };

  return (
    <Button onClick={onShare} size={size} variant={variant} aria-label="Share spot">
      <Share2 className="h-4 w-4" />
    </Button>
  );
}
